import React, { useEffect } from 'react'
import { Alvo } from './abrir'
import './confirmarAbertura.scss'

interface Props {
  alvo: Alvo
  /** A pessoa tocou em Abrir. O endereço abre pelo próprio link, que é um toque de verdade no portal e por isso funciona em qualquer navegador. */
  aoAbrir: () => void
  aoCancelar: () => void
}

/**
 * A pergunta que o portal faz quando o navegador não deixa abrir sozinho (comum no iPhone) ou quando o destino é uma ligação.
 * Mostra para onde vai antes de ir: a pessoa vê o número, a mensagem pronta ou o site.
 */
export default function ConfirmarAbertura({ alvo, aoAbrir, aoCancelar }: Props) {
  useEffect(() => {
    const tecla = (e: KeyboardEvent) => { if (e.key === 'Escape') aoCancelar() }
    window.addEventListener('keydown', tecla)
    return () => window.removeEventListener('keydown', tecla)
  }, [aoCancelar])

  return (
    <div className="ca-fundo" role="presentation" onClick={aoCancelar}>
      <div className="ca-caixa" role="dialog" aria-modal="true" aria-labelledby="ca-titulo" onClick={e => e.stopPropagation()}>
        <h3 id="ca-titulo">{alvo.titulo}</h3>
        <p className="ca-detalhe">{alvo.detalhe}</p>
        {alvo.tipo === 'link' && <p className="ca-aviso">Você vai sair do portal. Confira o endereço antes de abrir.</p>}
        {alvo.mensagem && <blockquote className="ca-mensagem">{alvo.mensagem}</blockquote>}
        <div className="ca-acoes">
          <button type="button" className="ca-cancelar" onClick={aoCancelar}>Cancelar</button>
          <a className="ca-abrir" href={alvo.url} target={alvo.tipo === 'telefone' ? undefined : '_blank'} rel="noopener noreferrer" onClick={aoAbrir}>
            {alvo.botao}
          </a>
        </div>
      </div>
    </div>
  )
}
